
import Header from "@/components/header/header.vue";
import DropDown from "@/components/drop-down/index.vue";
import { reactive, ref, inject, shallowRef} from "vue";
import { Toast } from "vant";
import { useRouter, useRoute } from "vue-router";
export default {
  components: {
    Header,
    DropDown,
  },
  beforeRouteEnter(to: any, from: any, next: any) {
    if (!common.getStorage('routerName')) {
      common.setStorage('routerName', from.fullPath)
    }
    next((vm: any) => {
    })
  },
  beforeRouteLeave(to: any, from: any, next: any){
    if(to.path != '/province'){
      sessionStorage.removeItem('isFiltrate')
    }
    next()
  },
  setup() {
    const router: any = useRouter();
    const usete: any = useRoute();
    const $http: any = inject("$http");
    const $store: any = inject("$store");
    //表单数据
    let state = reactive({
      phone: common.getStorage("address")
        ? common.getStorage("address").phone
        : "",
      firstName: common.getStorage("address")
        ? common.getStorage("address").firstName
        : "",
      LastName: common.getStorage("address")
        ? common.getStorage("address").LastName
        : "",
      County: usete.query.area_name ? usete.query.area_name : "",
      Town: usete.query.town_name ? usete.query.town_name : "",
      pickup: usete.query.pickup_id > 0 ? usete.query.pickup_name : "",
      checked: common.getStorage("address")
        ? common.getStorage("address").is_default
        : false,
      country_code: "254",
      type_door: true,
      area_door_id: 0,
      type_active:true,
      pickupout: usete.query.pickup_id > 0 ? "" : usete.query.pickup_name,
      isFiltrate: usete.query.isFiltrate  ? usete.query.isFiltrate: sessionStorage.getItem('isFiltrate'),
    });
    let stations_list = shallowRef([])
    // 是否来源于下单页
    if(usete.query.is_checkout) {
      sessionStorage.setItem('is_checkout', '1')
    }
    // 是否来源于售后页面
    if(usete.query.isShowCheck){
      sessionStorage.setItem('isShowCheck', '1')
    }
    // 是否需要筛选可上门取件地址
    if(usete.query.isFiltrate){
      sessionStorage.setItem('isFiltrate', usete.query.isFiltrate)
    }
    // 过滤文本前后不能输入空格
    const myTrim = (x: any) => {
      return x.replace(/^\s+|\s+$/gm,'');
    }
    //电话号码正则验证
    let validator = (value: string, rule: any) => {
      let reg = /^[1-9]{1}[0-9]{8}$/g;
      if (!reg.test(value)) {
        rule.message =
          "The wrong Phone number format, the correct format such as: 700200100";
        return false;
      } else {
        return true;
      }
    };
    //号码默认提示
    const message = (value: string, rule: any) => {
      return "Please input valid phone number.";
    };
    const rules = reactive({
      phone: [{ validator: validator, message: 'Please input valid phone number.', required: true }],
    });
    //弹框提示
    const onFailed = (errorInfo: any) => {
      Toast(errorInfo.errors[0].message);
    };
    //获取电话号前缀
    const onDropDown = (val: string): void => {
      state.country_code = val;
    };
    //省市区跳转
    const newlyIncreased = (val: String) => {
      let parms = {
        phone: state.phone,
        firstName: state.firstName,
        LastName: state.LastName,
        country_code: state.country_code,
      };
      //判断是编辑还是新增
      if (!common.getStorage("address")) {
        common.setStorage("address", parms, 15);
      } else {
        //修改的时候路由跳转数据不会丢失
        let copy = common.getStorage("address");
        copy.phone = state.phone;
        copy.firstName = state.firstName;
        copy.LastName = state.LastName;
        copy.country_code = state.country_code;
        common.setStorage("address", copy, 15);
      }
      if (val === "County") {
        router.push({
          path: "/province",
          query: {
            current_id: usete.query.area_id ? usete.query.area_id : "",
            name: "county",
          },
        });
      } else if (val === "Town") {
        if (state.County) {
          router.push({
            path: "/province",
            query: {
              area_id: usete.query.area_id ? usete.query.area_id : "",
              area_name: usete.query.area_name,
              current_id: usete.query.row_id ? usete.query.row_id : "",
              name: "town",
              isFiltrate:sessionStorage.getItem('isFiltrate')
            },
          });
        }
      } else if (val === "pickup") {
        router.push({
          path: "/pickup",
          query: {
            area_id: usete.query.area_id,
            area_name: usete.query.area_name,
            row_id: usete.query.row_id,
            town_name: usete.query.town_name,
            pickup_id: usete.query.pickup_id,
            area_door: usete.query.area_door,
            pickupout: state.pickupout,
          },
        });
      }
    };
    //判断是否自己填写地址栏
    if (usete.query.row_id) {
      $http
        .post_areas({ parent_id: usete.query.area_id, size: 100 })
        .then((res: any) => {
          if (res.code === 200 && res.data.length >= 0) {
            res.data.forEach((element: any) => {
              if (element.area_id === parseInt(usete.query.row_id)) {
                state.area_door_id = element.area_door;
                if (usete.query.pickup_id > 0) {
                  state.type_door = true;
                } else {
                  state.type_door = false;
                }
              }
            });
          }
        });
      $http.post_stations({ area_id: usete.query.row_id }).then((res: any) => {
        console.log('res多选', res);
        if (res.code === 200) {
          stations_list.value = res.data
        }
      })
    }
    // 选择的城市支持上门取件 并且当前需要进行是否可以上门的筛选 直接显示填写地址
    if(usete.query.area_pickup== '1'&&state.isFiltrate=='1'){
      state.area_door_id = 1
      state.type_active=false
    }
    //是否自己输入自提点
    const pickupDeliver = (val: any) => {
      state.type_door = val;
      state.type_active = val;
    };
    //提交
    const onSubmit = async (values: any) => {
      let param = {
        firstname: myTrim(state.firstName),
        lastname: myTrim(state.LastName),
        pronvice_id: myTrim(usete.query.area_id),
        city_id: myTrim(usete.query.row_id),
        dlyp_id: usete.query.pickup_id ? myTrim(usete.query.pickup_id) : "",
        address: state.pickup ? myTrim(state.pickup) : myTrim(state.pickupout),
        country_code: myTrim(state.country_code),
        phone: myTrim(state.phone),
        is_default: state.checked == true ? 1 : 0,
        action: common.getStorage("address").action? common.getStorage("address").action: "create",
        address_id: common.getStorage("address").address_id ? common.getStorage("address").address_id : undefined,
      };
      console.log(param, '----------param-======')
      let res = await $http.post_address(param);
      if (res.code === 200) {
        Toast("Save");
        common.delStorage("address");
        if (sessionStorage.getItem('is_checkout') === '1') {
          router.push("/checkout?address_id=" + res.data.address_id);
        } else if (sessionStorage.getItem('isShowCheck') === '1') {
          // 前往售后页面
          router.push({
            name: $store.getGoBack().replace('/',''),
            params: {
              addressMsg: res?.data?.address_id ?? param.address_id,
            }
          });

        }
        else {
          router.push("/address-list");
        }
        sessionStorage.removeItem('isShowCheck')
      } else {
        Toast(res.message);
      }
    };
    let skipPath = () => {
      let routerName: any = common.getStorage("routerName")
      if (routerName) {
        common.delStorage('routerName')
        router.push(routerName)
      }
    }
    return {
      state,
      rules,
      onFailed,
      onSubmit,
      newlyIncreased,
      onDropDown,
      usete,
      myTrim,
      pickupDeliver,
      stations_list,
      skipPath
    };
  },
};
